export const icons = [
	{ id: 'icon-altex', w: 30, h: 30 },
	{ id: 'icon-altex', w: 30, h: 30 },
	{ id: 'icon-altex', w: 30, h: 30 },
	{ id: 'vacPaid', w: 30, h: 30 },
	{ id: 'route', w: 30, h: 30 },
	{ id: 'icon-notifications', w: 30, h: 30 },
	{ id: 'speedometer', w: 30, h: 30 },
	{ id: 'routeMap', w: 30, h: 30 },
	{ id: 'number', w: 30, h: 30 },
	{ id: 'pickup', w: 30, h: 30 },
	{ id: 'delivery', w: 30, h: 30 },
	{ id: 'logoMob', w: 30, h: 30 },
	{ id: 'ruler-pencil', w: 30, h: 30 },
	{ id: 'doc-config', w: 30, h: 30 },
	{ id: 'vacNoPaid', w: 30, h: 30 },
	{ id: 'weekMon', w: 30, h: 30 },
	{ id: 'weekTue', w: 30, h: 30 },
	{ id: 'weekWed', w: 30, h: 30 },
	{ id: 'weekThu', w: 30, h: 30 },
	{ id: 'weekFri', w: 30, h: 30 },
	{ id: 'weekSat', w: 30, h: 30 },
	{ id: 'weekSun', w: 30, h: 30 },
	{ id: 'icon-omni', w: 30, h: 30 },
	{ id: 'icon-fleet', w: 30, h: 30 },
	{ id: 'icon-version', w: 30, h: 30 },
	{ id: 'icon-halloweenTomb', w: 30, h: 30 },
	{ id: 'icon-company', w: 30, h: 30 },
	{ id: 'icon-comments', w: 30, h: 30 },
	{ id: 'icon-User_Card_ID', w: 30, h: 30 },
	{ id: 'snoozeWeekend', w: 30, h: 30 },
	{ id: 'icon-plus', w: 30, h: 30 },
	{ id: 'icon-pay', w: 30, h: 30 },
	{ id: 'icon-bbq', w: 30, h: 30 },
	{ id: 'icon-magic', w: 30, h: 30 },
	{ id: 'icon-info', w: 30, h: 30 },
	{ id: 'icon-document', w: 30, h: 30 },
	{ id: 'icon-calendar-exclamation', w: 30, h: 30 },
	{ id: 'icon-no-perm', w: 30, h: 30 },
	{ id: 'icon-moneyUpdate', w: 30, h: 30 },
	{ id: 'icon-total', w: 30, h: 30 },
	{ id: 'close', w: 30, h: 30 },
	{ id: 'icLocation', w: 30, h: 30 },
	{ id: 'HomeWifi', w: 30, h: 30 },
	{ id: 'arrowDropDown', w: 30, h: 30 },
	{ id: 'comment', w: 30, h: 30 },
	{ id: 'Umbrella', w: 30, h: 30 },
	{ id: 'Binoculars', w: 30, h: 30 },
	{ id: 'Medicine', w: 30, h: 30 },
	{ id: 'InfoCircle', w: 30, h: 30 },
	{ id: 'Phone', w: 30, h: 30 },
	{ id: 'icon-Inventory', w: 30, h: 30 },
	{ id: 'icon-Formula', w: 30, h: 30 },
	{ id: 'icon-minute', w: 30, h: 30 },
	{ id: 'icon-hour', w: 30, h: 30 },
	{ id: 'icon-day', w: 30, h: 30 },
	{ id: 'HourglassHalf', w: 30, h: 30 },
	{ id: 'HexagonExclamation', w: 30, h: 30 },
	{ id: 'FingerprintAlt', w: 30, h: 30 },
	{ id: 'icon-Email', w: 30, h: 30 },
	{ id: 'icon-ListDuties', w: 30, h: 30 },
	{ id: 'icon-zoom-in', w: 30, h: 30 },
	{ id: 'icon-user', w: 30, h: 30 },
	{ id: 'icon-copy', w: 30, h: 30 },
	{ id: 'icon-Telegram', w: 30, h: 30 },
	{ id: 'icon-Whatsapp', w: 30, h: 30 },
	{ id: 'icon-Viber', w: 30, h: 30 },
	{ id: 'icon-Mobile', w: 30, h: 30 },
	{ id: 'icon-link', w: 30, h: 30 },
	{ id: 'ArrowRightFromArc', w: 30, h: 30 },
	{ id: 'ArrowRightToArc', w: 30, h: 30 },
	{ id: 'cat', w: 30, h: 30 },
	{ id: 'CircleQuestion', w: 30, h: 30 },
	{ id: 'TriangleExclamation', w: 30, h: 30 },
	{ id: 'CreditCard', w: 30, h: 30 },
	{ id: 'CreditCardPlus', w: 30, h: 30 },
	{ id: 'CreditCardMinus', w: 30, h: 30 },
	{ id: 'CircleQuestion', w: 30, h: 30 },
	{ id: 'MoneyReceive', w: 30, h: 30 },
	{ id: 'department', w: 30, h: 30 },
	{ id: 'directory', w: 30, h: 30 },
	{ id: 'statistics-chart-graph', w: 30, h: 30 },
	{ id: 'MoneyTick', w: 30, h: 30 },
	{ id: 'TimeForward', w: 30, h: 30 },
	{ id: 'TimeCheck', w: 30, h: 30 },
	{ id: 'TimeAdd', w: 30, h: 30 },
	{ id: 'TimeFast', w: 30, h: 30 },
	{ id: 'calendar0', w: 30, h: 30 },
	{ id: 'calendar1', w: 30, h: 30 },
	{ id: 'email0', w: 30, h: 30 },
	{ id: 'crown', w: 30, h: 30 },
	{ id: 'users0', w: 30, h: 30 },
	{ id: 'dollar-sign', w: 30, h: 30 },
	{ id: 'sun', w: 30, h: 30 },
	{ id: 'calendarAlt', w: 30, h: 30 },
	{ id: 'money-check-dollar', w: 30, h: 30 },
	{ id: 'cardUser', w: 30, h: 30 },
	{ id: 'folderUser', w: 30, h: 30 },
	{ id: 'bat', w: 30, h: 30 },
	{ id: 'partyHorn', w: 30, h: 30 },
	{ id: 'mapPin', w: 30, h: 30 },
	{ id: 'email1', w: 30, h: 30 },
	{ id: 'arrowDropDownLocation', w: 30, h: 30 },
	{ id: 'arrowDropUpLocation', w: 30, h: 30 },
	{ id: 'menu', w: 30, h: 30 },
	{ id: 'logo', w: 30, h: 30 },
	{ id: 'radio', w: 30, h: 30 },
	{ id: 'next', w: 30, h: 30 },
	{ id: 'user', w: 30, h: 30 },
	{ id: 'lock', w: 30, h: 30 },
	{ id: 'previous', w: 30, h: 30 },
	{ id: 'inspection', w: 30, h: 30 },
	{ id: 'alignment', w: 30, h: 30 },
	{ id: 'pm', w: 30, h: 30 },
	{ id: 'icon_search', w: 30, h: 30 },
	{ id: 'icon_draggable', w: 30, h: 30 },
	{ id: 'towing', w: 30, h: 30 },
	{ id: 'refresh', w: 30, h: 30 },
	{ id: 'generate', w: 30, h: 30 },
	{ id: 'upload', w: 30, h: 30 },
	{ id: 'copy', w: 30, h: 30 },
	{ id: 'logout', w: 30, h: 30 },
	{ id: 'addItem', w: 30, h: 30 },
	{ id: 'deleteItem', w: 30, h: 30 },
	{ id: 'eye', w: 30, h: 30 },
	{ id: 'date', w: 30, h: 30 },
	{ id: 'reset', w: 30, h: 30 },
	{ id: 'link', w: 30, h: 30 },
	{ id: 'sort_up', w: 30, h: 30 },
	{ id: 'sort_down', w: 30, h: 30 },
	{ id: 'filter', w: 30, h: 30 },
	{ id: 'warn', w: 30, h: 30 },
	{ id: 'structure', w: 30, h: 30 },
	{ id: 'arrow', w: 30, h: 30 },
	{ id: 'edit', w: 30, h: 30 },
	{ id: 'icon_back', w: 30, h: 30 },
	{ id: 'icon_miles', w: 30, h: 30 },
	{ id: 'icon_dollars', w: 30, h: 30 },
	{ id: 'icon_dollars_radio', w: 30, h: 30 },
	{ id: 'icon_history', w: 30, h: 30 },
	{ id: 'icon_download', w: 30, h: 30 },
	{ id: 'icon_send', w: 30, h: 30 },
	{ id: 'icon_view', w: 30, h: 30 },
	{ id: 'icon_percent', w: 30, h: 30 },
	{ id: 'icon_mi', w: 30, h: 30 },
	{ id: 'icon_hh', w: 30, h: 30 },
	{ id: 'icon_ft', w: 30, h: 30 },
	{ id: 'icon_dollar', w: 30, h: 30 },
	{ id: 'setting', w: 30, h: 30 },
	{ id: 'check', w: 30, h: 30 },
	{ id: 'customerLogo', w: 30, h: 30 },
	{ id: 'done', w: 30, h: 30 },
	{ id: 'warning', w: 30, h: 30 },
	{ id: 'stepSuccess', w: 30, h: 30 },
	{ id: 'stepEdit', w: 30, h: 30 },
	{ id: 'ok', w: 30, h: 30 },
	{ id: 'resetPassword', w: 30, h: 30 },
	{ id: 'st_true', w: 30, h: 30 },
	{ id: 'st_false', w: 30, h: 30 },
	{ id: 'st_1', w: 30, h: 30 },
	{ id: 'st_2', w: 30, h: 30 },
	{ id: 'st_3', w: 30, h: 30 },
	{ id: 'box', w: 30, h: 30 },
	{ id: 'clip0_6676_5699', w: 30, h: 30 },
	{ id: 'arrow_left', w: 30, h: 30 },
	{ id: 'arrow_right', w: 30, h: 30 },
	{ id: 'ellipsis', w: 30, h: 30 },
	{ id: 'pay', w: 30, h: 30 },
	{ id: 'not_pay', w: 30, h: 30 },
	{ id: 'plus', w: 30, h: 30 },
	{ id: 'profile', w: 30, h: 30 },
	{ id: 'dispatch', w: 30, h: 30 },
	{ id: 'safety', w: 30, h: 30 },
	{ id: 'statistics', w: 30, h: 30 },
	{ id: 'accounting', w: 30, h: 30 },
	{ id: 'maintenance', w: 30, h: 30 },
	{ id: 'feedback', w: 30, h: 30 },
	{ id: 'settings', w: 30, h: 30 },
	{ id: 'logOut', w: 30, h: 30 },
	{ id: 'calculator', w: 30, h: 30 },
	{ id: 'generateFile', w: 30, h: 30 },
	{ id: 'paid', w: 30, h: 30 },
	{ id: 'reChange', w: 30, h: 30 },
	{ id: 'feedback', w: 30, h: 30 },
	{ id: 'truck_van', w: 30, h: 30 },
	{ id: 'van', w: 30, h: 30 },
	{ id: 'truck_flatbed', w: 30, h: 30 },
	{ id: 'flatbed', w: 30, h: 30 },
	{ id: 'truck_reefer', w: 30, h: 30 },
	{ id: 'reefer', w: 30, h: 30 },
	{ id: 'icon_edit', w: 30, h: 30 },
	{ id: 'dat', w: 30, h: 30 },
	{ id: 'attention', w: 30, h: 30 },
	{ id: 'safe', w: 30, h: 30 },
];
